module.exports = __webpack_public_path__ + "static/img/banner_bg@2x.64cb5285.png";